// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
    --primary-color: #0098e5;
    --secondary-color: #e0e0e0;
    --highlight-color: #f0f0f0;
}

@media (max-width: 768px) {
    .employee-list {
        margin-left: 50px;
        position: static;
    }
}
/* Layout */
.employee-list {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.employee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--highlight-color);
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
}

.employee-row:not(.employee-header):hover {
    background-color: var(--secondary-color);
}

.employee-row:nth-child(even) {
    background-color: var(--secondary-color);
}

.employee-row:nth-child(2) {
    background-color: var(--primary-color);
    color: #fff;
}

.employee-row:not(.employee-header) + .employee-row {
    margin-top: 10px;
}

.employee-header {
    font-size: 18px;
    font-weight: bold;
}

.employee-label {
    flex: 1 1;
    font-weight: bold;
    color: #f0f0f0;
}

.employee-value {
    flex: 1 1;
    text-align: left;
    margin-right: 10px;
    min-width: 100px;
    font: 18px Arial, sans-serif;
}

.employee-email {
    text-align: right;
    margin-right: 0;
}

.employee-action {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
}

.employee-action-button {
    margin-left: 10px;
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
}

.employee-action-button:hover {
    background-color: #2194cc;
}

/* Dropdown Content (Hidden by Default) */
.employee-action-menu-content {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    background-color: #f1f1f1;
    min-width: 160px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    z-index: 1;
}

/* Links inside the dropdown */
.employee-action-menu-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

/* Show the dropdown menu on hover */
.employee-action-button:hover + .employee-action-menu-content {
    display: block;
}

.employee-action-container {
    position: relative;
}

.employee-action-menu-content {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    font: 18px Arial, sans-serif;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    z-index: 1;
    top: 100%;
}

.employee-action-menu-content button{
/*    Add a border*/
    color: black;
    padding: 12px 16px;
    display: block;
}

.employee-action-container:hover .employee-action-menu-content {
    display: block;
}

/* Add the following CSS at the end of your existing CSS */
.search-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    z-index: 1;
}

.search-input {
    width: 100%;
    max-width: 400px;
    padding: 10px;
    font-size: 18px;
    border: 1px solid var(--secondary-color);
    border-radius: 5px;
    outline: none;
    position: relative;
}

.search-input::placeholder {
    color: var(--secondary-color);
}

`, "",{"version":3,"sources":["webpack://./src/pages/EmployeeList.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;AACJ;AACA,WAAW;AACX;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;IAChB,wCAAwC;IACxC,UAAU;AACd;;AAEA,8BAA8B;AAC9B;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,oCAAoC;AACpC;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,wCAAwC;IACxC,UAAU;IACV,SAAS;AACb;;AAEA;AACA,mBAAmB;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["/* Variables */\n:root {\n    --primary-color: #0098e5;\n    --secondary-color: #e0e0e0;\n    --highlight-color: #f0f0f0;\n}\n\n@media (max-width: 768px) {\n    .employee-list {\n        margin-left: 50px;\n        position: static;\n    }\n}\n/* Layout */\n.employee-list {\n    margin-left: 20px;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n}\n\n.employee-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: var(--highlight-color);\n    border-radius: 5px;\n    padding: 10px;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.employee-row:not(.employee-header):hover {\n    background-color: var(--secondary-color);\n}\n\n.employee-row:nth-child(even) {\n    background-color: var(--secondary-color);\n}\n\n.employee-row:nth-child(2) {\n    background-color: var(--primary-color);\n    color: #fff;\n}\n\n.employee-row:not(.employee-header) + .employee-row {\n    margin-top: 10px;\n}\n\n.employee-header {\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.employee-label {\n    flex: 1;\n    font-weight: bold;\n    color: #f0f0f0;\n}\n\n.employee-value {\n    flex: 1;\n    text-align: left;\n    margin-right: 10px;\n    min-width: 100px;\n    font: 18px Arial, sans-serif;\n}\n\n.employee-email {\n    text-align: right;\n    margin-right: 0;\n}\n\n.employee-action {\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: flex;\n    align-items: center;\n}\n\n.employee-action-button {\n    margin-left: 10px;\n    background-color: var(--primary-color);\n    color: #fff;\n    border: none;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.2s ease-in-out;\n}\n\n.employee-action-button:hover {\n    background-color: #2194cc;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.employee-action-menu-content {\n    display: none;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    background-color: #f1f1f1;\n    min-width: 160px;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.employee-action-menu-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Show the dropdown menu on hover */\n.employee-action-button:hover + .employee-action-menu-content {\n    display: block;\n}\n\n.employee-action-container {\n    position: relative;\n}\n\n.employee-action-menu-content {\n    display: none;\n    position: absolute;\n    background-color: #f1f1f1;\n    font: 18px Arial, sans-serif;\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n    z-index: 1;\n    top: 100%;\n}\n\n.employee-action-menu-content button{\n/*    Add a border*/\n    color: black;\n    padding: 12px 16px;\n    display: block;\n}\n\n.employee-action-container:hover .employee-action-menu-content {\n    display: block;\n}\n\n/* Add the following CSS at the end of your existing CSS */\n.search-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n    z-index: 1;\n}\n\n.search-input {\n    width: 100%;\n    max-width: 400px;\n    padding: 10px;\n    font-size: 18px;\n    border: 1px solid var(--secondary-color);\n    border-radius: 5px;\n    outline: none;\n    position: relative;\n}\n\n.search-input::placeholder {\n    color: var(--secondary-color);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
